import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Title() {
  return <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/about_us_hero_background.png)]">
      {}
      <div className="absolute inset-0 bg-primary/60 backdrop-blur-[2px]" />

      {}
      <div className="relative z-10 mx-auto max-w-4xl px-4 py-16 text-center sm:px-6 lg:px-8">
        <h1 className="animate-fade-in-up font-display text-4xl font-bold leading-[1.2] tracking-wide text-white md:text-5xl lg:text-6xl">
          About Align Physiotherapy
        </h1>
        
        <p className="animate-fade-in-up-delay-100 mx-auto mt-6 max-w-2xl font-sans text-lg leading-[1.6] text-white/90 md:text-xl">
          Expert, evidence-based physiotherapy care in the heart of Warmsworth, Doncaster. Where movement matters and recovery begins.
        </p>

        <div className="animate-fade-in-up-delay-200 mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
            <Button size="lg" className="min-w-[180px] bg-accent text-white shadow-medium hover:bg-accent-hover hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 transition-all duration-[150ms]">
              Book Appointment
            </Button>
          </Link>
          
          <Link to="/ServicesPage">
            <Button size="lg" variant="outline" className="min-w-[180px] border-2 border-white bg-white/10 text-white backdrop-blur-sm hover:bg-white/20 hover:-translate-y-0.5 transition-all duration-[150ms]">
              Our Services
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}